import React from 'react';
import {noop} from 'lodash';

import {FrontlineClientRole} from '/component/partial/report/FrontlineClientRole';
import LastOrderedDate from '/component/partial/report/LastOrderedDate';
import {PeopleRole} from '/component/partial/report/PeopleRole';
import PersonFullName from '/component/partial/report/PersonFullName';
import {RECENTLY_INACTIVE} from '/enum/peopleToContact.enum';
import {
  REPORT_CLIENT_TO_CONTACT,
  REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE,
} from '/enum/records.enum';
import {FILTER_TYPES} from '/enum/tealium.enum';

import {generateOnRecordPress} from '../PeopleToContact.util';
import {PeopleToContactDataProvider} from '../PeopleToContactDataProvider';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

interface RecentlyInactiveProps {
  featureFlag: {
    CC_SR: boolean;
  };
  onItemPress: (params: any) => void;
  onShowProfile: () => void;
  parentScreenName: string;
  showFullReport: boolean;
  reportParams: any;
}

export const RecentlyInactive: React.FC<RecentlyInactiveProps> = ({
  onItemPress = noop,
  onShowProfile = noop,
  parentScreenName = '',
  showFullReport = false,
  reportParams = null,
  featureFlag = {
    CC_SR: false,
  },
}) => {
  const {sortParam} = useRecordsSorting({
    recordsName: REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE,
  });

  const onViewMore = () => {
    onItemPress({
      recordsName: REPORT_CLIENT_TO_CONTACT,
      filterName: REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE,
    });
  };

  // if the context has not been initialized yet, we take sorting from
  // the parent (default sorting)
  const defaultSorting = sortParam?.params
    ? [{...sortParam?.params}]
    : reportParams;
  return (
    <PeopleToContactDataProvider
      screenParams={{type: RECENTLY_INACTIVE}}
      clientMilestone={FILTER_TYPES.recentlyInactive}
      onViewMore={onViewMore}
      reportParams={defaultSorting}
      reportName={REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE}
      parentScreenName={parentScreenName}
      dataRendererProps={{
        personNameComponent: PersonFullName,
        personRoleComponent: featureFlag.CC_SR
          ? PeopleRole
          : FrontlineClientRole,
        personInfoComponent: LastOrderedDate,
        onRecordPress: generateOnRecordPress({
          onShowProfile,
        }),
        showFullReport,
      }}
    />
  );
};
